import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const SettingsContext = createContext({});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    systemName: 'The Black Div',
    systemSubtitle: 'Client Portal',
    logoUrl: null,
  });

  const load = async () => {
    try {
      const r = await axios.get('/api/settings');
      setSettings(r.data.data);
    } catch (_) {}
  };

  useEffect(() => { load(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, reload: load }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
